import router from "./router";
import store from "./store";
import { Message } from "element-ui";
import { getToken } from "@/utils/auth";

const permissionList = ["/account", "/user/favor", "/user/history"];

router.beforeEach((to, from, next) => {
  if (permissionList.indexOf(to.path) !== -1) {
    if (getToken()) {
      if (!store.getters.name) {
        store
          .dispatch("GetInfo")
          .then(() => {
            next();
          })
          .catch((err) => {
            store.dispatch("LogOut").then(() => {
              Message.error(err);
              next({ path: "/" });
            });
          });
      } else {
        next();
      }
    } else {
      // 没有token
      next(`/login?redirect=${encodeURIComponent(to.fullPath)}`); // 否则全部重定向到登录页
    }
  } else {
    next();
  }
});
